module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_black_friday-f86d1e79833ed4c626c8ead1887ead98.png";